import script from "./SetdayDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetdayDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SetdayDialog.vue?vue&type=style&index=0&id=2dd804ec&lang=scss"

const __exports__ = script;

export default __exports__